module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.fe241c6c.woff";